import theme from "./theme"

// Shadows
export const onePxThick = "box-shadow: 0 0 0 1px rgba(61,61,54,0.25);" // NORMAL
export const onePxElevation = "box-shadow: 0 0 3px 0 rgba(61,61,54,0.2), 0 1px 1px 1px rgba(61,61,54,0.2);"
export const twoPxElevation = "box-shadow: 0 0 3px 0 rgba(61,61,54,0.2), 0 2px 1px 2px rgba(61,61,54,0.15);"
export const threePxElevation = "box-shadow: 0 0 3px 0 rgba(61,61,54,0.2), 0 3px 2px 2px rgba(61,61,54,0.15);"
export const fourPxElevation = "box-shadow: 0 0 2px 0 rgba(61,61,54,0.1), 0 5px 3px 3px rgba(61,61,54,0.12);"
export const sixPxElevation = "box-shadow: 0 6px 4px 5px rgba(61,61,54,0.12);"
export const twoPxHighlight = `box-shadow: 0 2px 1px 2px ${theme.colors.greys.dropShadowGrey};`
export const twoPxShadow = "box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);"
export const twoPxShadowBigBlur = "box-shadow: 0 2px 30px 0 rgba(0, 0, 0, 0.1);"
export const threePxShadowBigBlur = "box-shadow: 0 3px 10px 2px rgba(0,0,0,.2);"
// inset
export const pressedState = "box-shadow: inset 0 -1px 0 0 rgba(61,61,54,0.25), inset 0 1px 0 1px rgba(61,61,54,0.25);"
export const pressedStateNoBorder = "box-shadow: inset 0.5px 1px 0.5px 0 rgba(61,61,54,0.25);"
export const thickState = "box-shadow: inset 0 1px 0 0 rgba(61,61,54,0.25), inset 0 -2px 0 1px rgba(61,61,54,0.25);"
export const insetTopThreePxElevation = "box-shadow: inset 0.5px 3px 0.5px 0 rgba(61,61,54,0.25);"
// clickable
export const clickable = "box-shadow: inset 0 0 0 1px rgba(61,61,54,0), 0 0 2px 0 rgba(61,61,54,0), 0 2px 1px 2px rgba(61,61,54,0.1);"

// New shadows kit
export const shadows = {
  low: "box-shadow: 0 2px 3px 1px rgba(59,59,54,0.12);",
  lowInset: "box-shadow: inset 0 2px 3px 1px rgba(59,59,54,0.12);",
  mid: "box-shadow: 0 4px 8px 0 rgba(12,0,51,0.1);",
  high: "box-shadow: 0 2px 8px 0 rgba(59,59,54,0.24);",
  buttonPressed:
    "box-shadow: inset 0 -1px 0 0 rgba(59,59,54,0.24), " + "inset 0 1px 0 1px rgba(59,59,54,0.24), 0 3px 8px 0 rgba(59,59,54,0.24);",
  headerDropdown: "box-shadow: 0 3px 3px 1px rgba(59,59,54,0.12);"
}

export default {
  onePxElevation,
  onePxThick,
  twoPxElevation,
  twoPxHighlight,
  threePxElevation,
  fourPxElevation,
  sixPxElevation,
  pressedState,
  pressedStateNoBorder,
  thickState,
  insetTopThreePxElevation,
  twoPxShadow,
  twoPxShadowBigBlur,
  clickable,
  shadows
}
